import React, { useState } from 'react';

import Close from '@sats-group/icons/16/close';
import type { Message } from '@sats-group/ui-lib/react/message/message.types';
import type { VisuallyButton } from '@sats-group/ui-lib/react/visually-button/visually-button.types';

import type { Language } from '../types/types';
import { texts } from '../utils/texts';

export const useMessage = (messages: Message[], language: Language) => {
  const [messagesQueue, setMessagesQueue] = useState(messages);

  const removeMessage = (message: Message) => {
    setMessagesQueue(prev => prev.filter(item => item !== message));
  };

  const getAction = (message: Message): VisuallyButton => ({
    elementName: 'button',
    onClick: () => removeMessage(message),
    text: texts[language].close,
    leadingIcon: React.createElement(Close),
    iconOnly: true,
  });

  return {
    messagesQueue,
    removeMessage,
    getAction,
  };
};
